import { DashboardContainer } from "@/design-system/Organisms";

const DashboardTemplate = () => {
  return (
    <>
       <DashboardContainer />
    </>
  );
};

export default DashboardTemplate;
